export const TRANSLATOR_ACTIONS = {
    GET: 'TRANSLATOR_GET',
    CLEAN: 'TRANSLATOR_CLEAN',
}